module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sgc-1"
  }, [_vm._v("Other WildBlue Press Books By Steve Jackson ")]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "sgc-2"
  }, [_vm._v("Smooth Talker")]), _vm._v(" "), _c('p', {
    staticClass: "sgc-3"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/smoothtalker",
      "target": "_blank"
    }
  }, [_vm._v("http://wbp.bz/smoothtalker")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-2"
  }, [_vm._v("No Stone Unturned")]), _vm._v(" "), _c('p', {
    staticClass: "sgc-3"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/nsua",
      "target": "_blank"
    }
  }, [_vm._v("http://wbp.bz/nsua")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-2"
  }, [_vm._v("Rough Trade")]), _vm._v(" "), _c('p', {
    staticClass: "sgc-3"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/rta",
      "target": "_blank"
    }
  }, [_vm._v("http://wbp.bz/rta")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-2"
  }, [_vm._v("A Clockwork Murder")]), _vm._v(" "), _c('p', {
    staticClass: "sgc-3"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/clockworkmurdera",
      "target": "_blank"
    }
  }, [_vm._v("http://wbp.bz/clockworkmurdera")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaba4ecc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/OtherBooks.vue
// module id = 72
// module chunks = 0